import React from "react";

export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "90%",
  maxHeight: "80%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  overflowY: "scroll",
  boxShadow: 20,
  p: 2,
};
